import { Controller } from "@hotwired/stimulus";

// Bulk-actions controller for the Saved tab table.
// Selecting any row shows the action bar with: tag, add-to-list, remove.
export default class extends Controller {
  static targets = [
    "checkbox",
    "actionBar",
    "count",
    "tagInput",
    "selectAll",
    "listSelect",
  ];

  connect() {
    this.updateState();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => (cb.checked = checked));
    this.updateState();
  }

  toggle() {
    this.updateState();
  }

  updateState() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    const count = checked.length;

    if (this.hasActionBarTarget) {
      this.actionBarTarget.style.display = count > 0 ? "" : "none";
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count;
    }
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked =
        count > 0 && count === this.checkboxTargets.length;
    }
  }

  // Apply tag to all selected
  submit(event) {
    event?.preventDefault();
    const tagName = this.tagInputTarget.value.trim();
    if (!tagName) return;
    const ids = this._selectedIds();
    if (ids.length === 0) return;
    this._postForm("/saved_influencers/bulk_tag", {
      tag_name: tagName,
      "saved_influencer_ids[]": ids,
    });
  }

  // Bulk add to list (listSelect target carries the chosen list id)
  addToList(event) {
    event?.preventDefault();
    const listId = this.hasListSelectTarget && this.listSelectTarget.value;
    if (!listId) return;
    const ids = this._selectedIds();
    if (ids.length === 0) return;
    this._postForm(
      `/creator_lists/${listId}/creator_list_memberships/bulk_add`,
      { "saved_influencer_ids[]": ids }
    );
  }

  // Bulk remove selected from saved (with confirm)
  removeFromSaved(event) {
    event?.preventDefault();
    const ids = this._selectedIds();
    if (ids.length === 0) return;
    if (
      !window.confirm(
        `Remove ${ids.length} creator(s) from your saved list? This also removes them from any lists.`
      )
    )
      return;
    this._postForm("/saved_influencers/bulk_destroy", {
      "saved_influencer_ids[]": ids,
      _method: "delete",
    });
  }

  // ---- helpers ---------------------------------------------------------

  _selectedIds() {
    return this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);
  }

  _postForm(action, fields) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = action;

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrf) {
      const i = document.createElement("input");
      i.type = "hidden";
      i.name = "authenticity_token";
      i.value = csrf;
      form.appendChild(i);
    }

    Object.entries(fields).forEach(([name, value]) => {
      const values = Array.isArray(value) ? value : [value];
      values.forEach((v) => {
        const i = document.createElement("input");
        i.type = "hidden";
        i.name = name;
        i.value = v;
        form.appendChild(i);
      });
    });

    document.body.appendChild(form);
    form.submit();
  }
}
